import React, { useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar
} from "../../../../../_metronic/_partials/controls";
import ProjectManageForm from "./ProjectBenefis";
import * as actions from "../../_redux/project/projectAction";
import { currencyFormatter } from "../../../../../_metronic/_helpers";
import moment from "moment";
import ProjectBenefis from "./ProjectBenefis";
import ModalBenefis from "../modal-for-project/ModalBenefis";
import ProjectExpense from "./ProjectExpense";
import ModalExpense from "../modal-for-project/ModalExpense";
import ConfirmationDeleteModal from "../modal-for-project/ConfirmationDeleteModal";
import LoadingAnimation from "../loading-animation/LoadingAnimation";
import ProjectImage from "./ProjectImage";
import ProjectIncome from "./ProjectIncome";
import ModalIncome from "../modal-for-project/ModalIncome";
import ModalEditIncome from "../modal-for-project/ModalEditIncome";
import ProjectDocument from "./ProjectDocument";
import ProjectBalance from "./ProjectBalance";
import { recapProject, recapProjectPublic } from "../../_redux/project/projectCrud";
import { CircularProgress } from "@material-ui/core";
import ProjectVideo from "./ProjectVideo";

export default function ProjectManage({
  match: {
    params: { id }
  },
  history
}) {
  // * SHOW MODAL
  const [showModal, setShowModal] = useState({
    benefis: false,
    expense: false,
    deleteExpense: false,
    income: false,
    incomeEdit: false
  });

  // * TABLE DATA
  const [tableData, setTableData] = useState({
    benefis: [],
    deletedBenefis: [],
    expense: [],
    income: []
  });

  //  * CURRENT SELECTED EXPENSE FOR DELETE
  const [currentExpense, setCurrentExpense] = useState({});

  // * PROJECT IMAGE
  const [projectImage, setProjectImage] = useState({
    currentImage: [],
    deletedImage: []
  });

  // * PROJECT VIDEO
  const [projectVideo, setProjectVideo] = useState({
    currentVideo: [],
    deletedVideo: []
  });

  // * Loading state download
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingPublic, setIsLoadingPublic] = useState(false);

  const dispatch = useDispatch();
  const { actionsLoading, projectManage = {}, error } = useSelector(
    state => ({
      actionsLoading: state.project.actionsLoading,
      projectManage: state.project.projectManage,
      error: state.project.error
    }),
    shallowEqual
  );

  // * FETCH PROJECT BY ID
  useEffect(() => {
    // server call for getting Project by id
    dispatch(actions.fetchProjectManage(id));
  }, [id, dispatch]);

  useEffect(() => {
    if (projectManage.project_expense) {
      setTableData(prevState => ({
        ...prevState,
        expense: projectManage.project_expense
      }));
    }
    if (projectManage.gallery) {
      setProjectImage(prevState => ({
        ...prevState,
        currentImage: projectManage.gallery
      }));
    }
    if (projectManage.videos) {
      setProjectVideo(prevState => ({
        ...prevState,
        currentVideo: projectManage.videos
      }));
    }
    if (projectManage.benefis) {
      setTableData(prevState => ({
        ...prevState,
        benefis: projectManage.benefis
      }));
    }

    if (projectManage.project_income) {
      setTableData(prevState => ({
        ...prevState,
        income: projectManage.project_income
      }));
    }
  }, [projectManage]);

  // * ADD BENEFIS DATA TO TABLE
  const addBenefisTable = value => {
    setTableData(prevState => {
      const arrCopy = [...prevState.benefis];
      const sameValue = arrCopy.some(item => item.uuid === value.uuid);
      if (!sameValue) arrCopy.push(value);
      return {
        ...prevState,
        benefis: arrCopy
      };
    });
  };

  // * REMOVE BENEFIS DATA FROM TABLE
  const removeBenefisTable = uuid => {
    setTableData(prevState => {
      //  * TABLE BENEFIS
      const arrCopy = [...prevState.benefis];
      const newData = arrCopy.filter(item => item.uuid !== uuid);

      // * DELETED BENEFIS
      const deletedArr = [...prevState.deletedBenefis];
      deletedArr.push({ uuid: uuid });
      return {
        ...prevState,
        benefis: newData,
        deletedBenefis: deletedArr
      };
    });
  };

  //  * SAVE BENEFIS
  const saveBenefis = () => {
    const data = {
      uuid: id,
      benefis_add: tableData.benefis,
      benefis_remove: tableData.deletedBenefis
    };
    dispatch(actions.createProjectBenefis(data)).then(() =>
      dispatch(actions.fetchProjectManage(id))
    );
  };

  // * DELETE EXPENSE
  const deleteExpense = () => {
    dispatch(
      actions.deleteProjectExpanse({
        project_uuid: id,
        uuid: currentExpense.uuid
      })
    ).then(() => {
      dispatch(actions.fetchProjectManage(id));
      setShowModal(prevState => ({ ...prevState, deleteExpense: false }));
    });
  };

  // * Upload Files
  function createProjectFile(type, values, callback) {
    const formData = new FormData();

    const { caption, file } = values;

    formData.append("type", type);
    formData.append("file", file);
    formData.append("caption", caption);

    dispatch(actions.uploadProjectFile(id, formData)).then(() => {
      dispatch(actions.fetchProjectManage(id));

      if (callback instanceof Function) {
        callback();
      }
    });
  }

  function uploadProjectDocument(values, cb) {
    createProjectFile("document", values, cb);
  }

  function uploadProjectImage(values, cb) {
    createProjectFile("gallery", values, cb);
  }

  function uploadProjectVideo(values, cb) {
    createProjectFile("video", values, cb);
  }

  // * REMOVE IMAGE
  const removeImage = image => {
    setProjectImage(prevState => {
      // * CHANGE CURRENT IMAGE
      const currentImgArr = [...prevState.currentImage];
      const newArray = currentImgArr.filter(item => item.uuid !== image.uuid);

      // * DELETED IMAGE ARRAY
      const deletedImgArr = [...prevState.deletedImage];
      deletedImgArr.push(image);

      return {
        ...prevState,
        currentImage: newArray,
        deletedImage: deletedImgArr
      };
    });
  };

  // * REMOVE VIDEO
  const removeVideo = video => {
    setProjectVideo(prevState => {
      // * CHANGE CURRENT VIDEO
      const currentVideoArr = [...prevState.currentVideo];
      const newArray = currentVideoArr.filter(item => item.uuid !== video.uuid);

      // * DELETED VIDEO ARRAY
      const deletedVideoArr = [...prevState.deletedVideo];
      deletedVideoArr.push(video);

      return {
        ...prevState,
        currentVideo: newArray,
        deletedVideo: deletedVideoArr
      };
    });
  };

  // * DELETE IMAGE
  function deleteImage() {
    const data = {
      uuid: id,
      gallery_remove: projectImage.deletedImage
    };
    dispatch(actions.deleteProjectFile(data)).then(() =>
      dispatch(actions.fetchProjectManage(id))
    );
    setProjectImage(prevState => ({
      ...prevState,
      deletedImage: []
    }));
  }

  // * DELETE VIDEO
  function deleteVideo() {
    const data = {
      uuid: id,
      gallery_remove: projectVideo.deletedVideo
    };

    dispatch(actions.deleteProjectFile(data)).then(() =>
      dispatch(actions.fetchProjectManage(id))
    );

    setProjectVideo(prevState => ({
      ...prevState,
      deletedVideo: []
    }));
  }

  // * DELETE DOCUMENT
  function deleteDocument(doc, callback) {
    const payload = {
      uuid: id,
      gallery_remove: [doc]
    };

    dispatch(actions.deleteProjectFile(payload)).then(() => {
      dispatch(actions.fetchProjectManage(id));

      if (callback instanceof Function) {
        callback();
      }
    });
  }

  async function downloadRecapProject() {
    if (!id || isLoading) {
      return;
    }

    try {
      setIsLoading(true);

      const res = await recapProject(id);

      const url = URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");
      link.href = url;
      link.target = "_blank";
      link.setAttribute(
        "download",
        `Rekap ${moment()
          .locale("id")
          .format("DD MMMM YYYY")} ${projectManage.name}.pdf`
      );

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  }

  async function downloadRecapProjectPublic() {
    if (!id || isLoadingPublic) {
      return;
    }

    try {
      setIsLoadingPublic(true);

      const res = await recapProjectPublic(id);

      const url = URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");
      link.href = url;
      link.target = "_blank";
      link.setAttribute(
        "download",
        `Rekap Publik ${moment()
          .locale("id")
          .format("DD MMMM YYYY")} ${projectManage.name}.pdf`
      );

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
    } finally {
      setIsLoadingPublic(false);
    }
  }
  return (
    <>
      <LoadingAnimation open={actionsLoading} />
      {/* Modal Benefis */}
      <ModalBenefis
        show={showModal.benefis}
        onHide={() =>
          setShowModal(prevState => ({ ...prevState, benefis: false }))
        }
        setSelectedBenefis={addBenefisTable}
      />

      {/* Modal Expense */}
      <ModalExpense
        show={showModal.expense}
        onHide={() => {
          setShowModal(prevState => ({ ...prevState, expense: false }));
          setCurrentExpense({});
        }}
        projectId={id}
        initValues={currentExpense}
        projectBalance={projectManage.project_balance}
      />

      {/* Confirmation Modal */}
      <ConfirmationDeleteModal
        show={showModal.deleteExpense}
        onHide={() => {
          setShowModal(prevState => ({
            ...prevState,
            deleteExpense: false
          }));
          setCurrentExpense({});
        }}
        title={`Hapus ${currentExpense.description}`}
        content={`Apakah anda yakin ingin menghapus ${currentExpense.description}`}
        onClick={deleteExpense}
      />

      {/* Create Income Modal */}
      <ModalIncome
        id={id}
        show={showModal.income}
        onHide={() => {
          setShowModal(prevState => ({
            ...prevState,
            income: false
          }));
        }}
      />

      <ModalEditIncome
        id={id}
        show={showModal.incomeEdit}
        onHide={() => {
          setShowModal(prevState => ({
            ...prevState,
            incomeEdit: false
          }));
        }}
      />

      <Card>
        <CardHeader title="Kelola Projek">
          <CardHeaderToolbar>
            <button
              className="btn btn-outline-dark mx-1"
              onClick={downloadRecapProjectPublic}
            >
              {isLoadingPublic ? (
                <CircularProgress size={15} color="inherit" />
              ) : (
                <span>Download Publik</span>
              )}
            </button>
            <button
              className="btn btn-outline-dark mx-1"
              onClick={downloadRecapProject}
            >
              {isLoading ? (
                <CircularProgress size={15} color="inherit" />
              ) : (
                <span>Download Internal</span>
              )}
            </button>
            <button
              className="btn btn-secondary mx-1"
              onClick={() => history.push("/_distribution/project")}
            >
              <i className="fa fa-arrow-left" />
              Kembali
            </button>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <div className="row mb-4">
            <div className="col-lg-3">Nama Proyek:</div>
            <div className="col-lg-9">{projectManage.name}</div>
          </div>
          <div className="row mb-4">
            <div className="col-lg-3">Periode:</div>
            <div className="col-lg-9">{`${moment(
              projectManage.begin_date
            ).format("YYYY-MM-DD")} - ${moment(projectManage.end_date).format(
              "YYYY-MM-DD"
            )}`}</div>
          </div>
          <div className="row mb-4">
            <div className="col-lg-3">Lokasi:</div>
            <div className="col-lg-9">{`${projectManage.district}, ${projectManage.city}, ${projectManage.province}`}</div>
          </div>
          <div className="row mb-4">
            <div className="col-lg-3">Target:</div>
            <div className="col-lg-9">
              {currencyFormatter(projectManage.target_revenue)}
            </div>
          </div>
        </CardBody>
      </Card>

      {/* PROJECT INCOME COMPONENT */}
      <ProjectIncome
        incomeData={tableData.income}
        openIncomeModal={() =>
          setShowModal(prevState => ({ ...prevState, income: true }))
        }
        openEditIncomeModal={() =>
          setShowModal(prevState => ({ ...prevState, incomeEdit: true }))
        }
        totalProjectIncome={projectManage.total_project_income}
      />

      {/* PROJECT EXPENSE COMPONENT */}
      <ProjectExpense
        showExpenseModal={values => {
          setShowModal(prevState => ({ ...prevState, expense: true }));
          if (values) setCurrentExpense(values);
        }}
        expenseData={tableData.expense}
        showConfirmationModal={values => {
          setShowModal(prevState => ({
            ...prevState,
            deleteExpense: true
          }));
          setCurrentExpense(values);
        }}
        totalProjectExpense={projectManage.total_project_expense}
      />

      {/* PROJECT BALANCE */}
      <ProjectBalance
        projectBalance={projectManage.project_balance}
        totalProjectIncome={projectManage.total_project_income}
        totalProjectExpense={projectManage.total_project_expense}
      />

      {/* PROJECT BENEFIS COMPONENT */}
      <ProjectBenefis
        showBenefisModal={() =>
          setShowModal(prevState => ({ ...prevState, benefis: true }))
        }
        benefisData={tableData.benefis}
        removeBenefis={removeBenefisTable}
        saveBenefis={saveBenefis}
      />

      {/* PROJECT IMAGE COMPONENT */}
      <ProjectImage
        uploadProjectImage={uploadProjectImage}
        images={projectImage.currentImage}
        removeImage={removeImage}
        deletedImage={projectImage.deletedImage}
        deleteImage={deleteImage}
      />

      <ProjectVideo
        uploadProjectVideo={uploadProjectVideo}
        videos={projectVideo.currentVideo}
        removeVideo={removeVideo}
        deletedVideos={projectVideo.deletedVideo}
        deleteVideos={deleteVideo}
      />

      <ProjectDocument
        createDocument={uploadProjectDocument}
        deleteDocument={deleteDocument}
        documents={(projectManage && projectManage.documents) ?? []}
      />
    </>
  );
}
